import { timestampDate } from '@bufbuild/protobuf/wkt'

import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'

import { LEMA_USER_ID } from '@/const/contact'

import { ONE_YEAR_AGO } from '@/lib/date/date'
import { useLastIrqChange } from '@/lib/risk/last-irq-change.hook'

import { NextPreAssessmentActionButton } from '@/pages/third-party-inventory/components/next-pre-assessment-action-button'

import { Alert } from '@/components/lemmala-design-system/alert/alert'
import { Button } from '@/components/lemmala-design-system/button/button'

type InherentRiskWarningAlertProps = {
  companyId: string
  companyStatus: CompanyStatus
  engagementModeEnabled: boolean
}

export const InherentRiskWarningAlert = ({
  companyId,
  companyStatus,
  engagementModeEnabled,
}: InherentRiskWarningAlertProps) => {
  const { lastIRQChange, isLoading } = useLastIrqChange(companyId)

  const isIrqEverCompletedByUser = lastIRQChange.userId !== LEMA_USER_ID
  const isIrqSetMoreThanYearAgo = lastIRQChange.time
    ? timestampDate(lastIRQChange.time) < ONE_YEAR_AGO
    : false
  const shouldShowWarning =
    lastIRQChange.time &&
    (!isIrqEverCompletedByUser || (isIrqEverCompletedByUser && isIrqSetMoreThanYearAgo))

  if (!shouldShowWarning || isLoading) {
    return null
  }

  return (
    <Alert
      variant='warning'
      className='mb-6 px-3 py-2'
      description={
        <>
          {isIrqEverCompletedByUser
            ? 'Inherent risk was set more than one year ago. Lema uses inherent risk to determine which controls to check.'
            : 'Validate the Inherent Risk Questionnaire before starting, since Lema uses it to decide which controls to check.'}{' '}
          <NextPreAssessmentActionButton
            engagementModeEnabled={engagementModeEnabled}
            companyId={companyId}
            status={companyStatus}
            from='assessment-tab-warning'
            actionButton={({ actionText, onClick }) => (
              <Button variant='link' className='h-auto p-0 underline' onClick={onClick}>
                {actionText}
              </Button>
            )}
          />
        </>
      }
    />
  )
}
